const navMenu = [
  { title: 'Home', href: '/' },
  { title: 'About', href: '/about' },
  { title: 'Services', href: '/services' },
  { title: 'Doctor', href: '/doctor' },
  { title: 'Contact', href: '/contact' },
];

export default navMenu;
